// extracted by mini-css-extract-plugin
module.exports = {"SaveBar":"SaveBar__ngANs"};